//配置
import PreAudit from './counselingConfig/preAudit'
import PreAuditImport from './counselingConfig/preAudit/import'
import PersonnelTraining from './counselingConfig/personnelTraining'
import LinchpinKPI from './counselingConfig/linchpinKPI'
import Satisfaction from './counselingConfig/satisfaction'
//融入辅导
import IntegrationCounseling from './manager'
import CounselingProcess from './counselingProcess'
//上线通知
import OnlineNotificationPostPersonnel from './counselingProcess/onlineNotification/postPersonnel'
import AdministratorSetting from './counselingProcess/onlineNotification/administratorSetting'
import StartNotification from './counselingProcess/onlineNotification/startNotification'
import SendNotification from './counselingProcess/onlineNotification/startNotification/sendNotification'
import LookNotification from './counselingProcess/onlineNotification/startNotification/lookNotification'
//前期介入
import AntecedentInterventionPostPersonnel from './counselingProcess/antecedentIntervention/postPersonnel'
import SalesOpening from './counselingProcess/antecedentIntervention/salesOpening'
import SalesOpeningExamine from './counselingProcess/antecedentIntervention/salesOpening/examine'
import SalesOpeningLook from './counselingProcess/antecedentIntervention/salesOpening/look'
import CallCar from './counselingProcess/antecedentIntervention/callCar'
import CallCarExamine from './counselingProcess/antecedentIntervention/callCar/examine'
import CallCarLook from './counselingProcess/antecedentIntervention/callCar/look'
import GeneralManagerEvaluation from './counselingProcess/antecedentIntervention/evaluation'
import GeneralManagerEvaluationExamine from './counselingProcess/antecedentIntervention/evaluation/examine'
//预审核
import PreAuditNotification from './counselingProcess/preAudit/notification'
import PreAuditSendNotification from './counselingProcess/preAudit/notification/sendNotification'
import PreAuditLookNotification from './counselingProcess/preAudit/notification/lookNotification'
import PreAuditResult from './counselingProcess/preAudit/result'
import PreAuditResultEvaluation from './counselingProcess/preAudit/result/evaluation'
import PreAuditResultLook from './counselingProcess/preAudit/result/look'
import PreAuditResultSend from './counselingProcess/preAudit/result/send'
// 跟踪
import TrackPersonnelTrain from './counselingProcess/track/personnelTrain'
import TrackPersonnelStability from './counselingProcess/track/personnelStability'
import TrackCruxKpi from './counselingProcess/track/cruxKpi'
import TrackCameraEvaluation from './counselingProcess/track/cameraEvaluation'
import TrackSatisfactionEvaluation from './counselingProcess/track/satisfactionEvaluation'
import TrackCameraEvaluationDetail from './counselingProcess/track/cameraEvaluation/detail'
import TrackCameraEvaluationComment from './counselingProcess/track/cameraEvaluation/comment'
//辅导
import CoachProcess from './counselingProcess/coach/detail'
import CoachProcessSend from './counselingProcess/coach/detail/send'
import CoachProcessLook from './counselingProcess/coach/detail/look'

//检核
import ReviewNotification from './counselingProcess/review/notification'
import ReviewSendNotification from './counselingProcess/review/notification/sendNotification'
import ReviewLookNotification from './counselingProcess/review/notification/lookNotification'
import ReviewResult from './counselingProcess/review/result'
import ReviewResultEvaluation from './counselingProcess/review/result/evaluation'
import ReviewResultLook from './counselingProcess/review/result/look'
import ReviewResultSend from './counselingProcess/review/result/send'


export {
    PreAudit,
    PreAuditImport,
    PersonnelTraining,
    LinchpinKPI,
    Satisfaction,
    IntegrationCounseling,
    CounselingProcess,
    OnlineNotificationPostPersonnel,
    AdministratorSetting,
    StartNotification,
    SendNotification,
    LookNotification,
    AntecedentInterventionPostPersonnel,
    SalesOpening,
    SalesOpeningExamine,
    SalesOpeningLook,
    CallCar,
    CallCarExamine,
    CallCarLook,
    GeneralManagerEvaluation,
    GeneralManagerEvaluationExamine,
    PreAuditNotification,
    PreAuditSendNotification,
    PreAuditLookNotification,
    PreAuditResult,
    PreAuditResultEvaluation,
    PreAuditResultLook,
    PreAuditResultSend,
    CoachProcess,
    CoachProcessSend,
    CoachProcessLook,
    TrackPersonnelTrain,
    TrackPersonnelStability,
    TrackCruxKpi,
    TrackCameraEvaluation,
    TrackCameraEvaluationDetail,
    TrackCameraEvaluationComment,
    TrackSatisfactionEvaluation,
    ReviewNotification,
    ReviewSendNotification,
    ReviewLookNotification,
    ReviewResult,
    ReviewResultEvaluation,
    ReviewResultLook,
    ReviewResultSend
}